import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';

const GenericGuideLinksBlock = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-links'>
            
            <div className='content-list-wrapper'>
                {
                    props.iContent.links?.expandedValue?.map((item, index) => {
                        return (
                            <a key={index} className='content-item' href='#' onClick={(e) => handleItemClick(e, item.link?.value)}>
                                {item.linkText?.value}
                            </a>
                        );
                    })
                }
            </div>

        </div>
    );

    function handleItemClick(e, link) {
        e.preventDefault();
        prepareUrl(link, EpiContext);
    }

};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideLinksBlock);